(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("1cE51", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c8e2181a3f3fb72d$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $5jxwZ = parcelRequire("5jxwZ");

var $kqTTL = parcelRequire("kqTTL");

var $cUbQm = parcelRequire("cUbQm");

const $c8e2181a3f3fb72d$var$ViewingBooking = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("eYlF4")));

const $c8e2181a3f3fb72d$var$InterestForm = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("gG0gS")));

const $c8e2181a3f3fb72d$var$ViewingItem = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("b2JAe")));
function $c8e2181a3f3fb72d$export$2e2bcd8739ae039() {
    const [selectedViewing, setSelectedViewing] = (0, $dTCkE.useState)();
    const [showHideModal, setShowHideModal] = (0, $dTCkE.useState)(false);
    const [showHideBookModal, setShowHideBookModal] = (0, $dTCkE.useState)(false);
    const [dataLayerClick, setDataLayerClick] = (0, $dTCkE.useState)(false);
    const [oneViewingDate, setOneViewingDate] = (0, $dTCkE.useState)(false);
    const [hasBookableViewing, setHasBookableViewing] = (0, $dTCkE.useState)(false);
    const [hasRegularViewing, setHasRegularViewing] = (0, $dTCkE.useState)(false);
    const { objectId: objectId, estate: estate, setOneViewing: setOneViewing, oneViewing: oneViewing } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    (0, $dTCkE.useEffect)(()=>{
        if (estate?.viewings && estate?.viewings.length === 1 && estate?.viewings[0]?.timeSlots?.length === 1 && oneViewing === false) setOneViewing(true);
        if (estate?.viewings && estate?.viewings?.length === 1) setOneViewingDate(true);
    }, [
        estate?.viewings
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "pt-4 lg:pt-4 lg:pb-0",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "px-4 xxl:px-6",
                    children: [
                        hasRegularViewing && /*#__PURE__*/ (0, $a9eYm.jsxs)("h3", {
                            className: "font-icb text-blue700 text-xl",
                            children: [
                                oneViewingDate && hasRegularViewing && /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                    children: "Visning"
                                }),
                                hasRegularViewing && !oneViewingDate && /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                    children: "Visningar"
                                })
                            ]
                        }),
                        estate?.viewings && estate?.viewings !== undefined && estate?.status.name != (0, $cUbQm.EstateStatuses).Sold && estate?.status.name != (0, $cUbQm.EstateStatuses).SoldOut && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: `${hasRegularViewing ? "mb-4" : ""}`,
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                children: estate?.viewings.map((viewing)=>/*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                        "data-id": viewing.id,
                                        className: "inline-block w-full viewing-item",
                                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                !hasRegularViewing && setHasRegularViewing(true),
                                                !hasBookableViewing && viewing.bookableFromInternet && !viewing.fullyBooked && new Date(viewing.noLaterThen) > new Date() && setHasBookableViewing(true),
                                                /*#__PURE__*/ (0, $a9eYm.jsx)($c8e2181a3f3fb72d$var$ViewingItem, {
                                                    viewing: viewing,
                                                    setShowHideModalFunction: setShowHideModal,
                                                    setSelectedViewingFunction: setSelectedViewing
                                                })
                                            ]
                                        })
                                    }, viewing?.id))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "px-4 xxl:px-6",
                    children: [
                        hasBookableViewing && estate?.status.name != (0, $cUbQm.EstateStatuses).Sold && estate?.status.name != (0, $cUbQm.EstateStatuses).SoldOut && /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                            className: "bg-blue700 mt-4 mb-2 px-3 py-3 rounded-md w-full font-icb text-white viewing-booking-button hover-darken-blue",
                            onClick: (e)=>{
                                setShowHideModal(true);
                                setDataLayerClick(true);
                            },
                            children: "Boka visning"
                        }),
                        (!estate?.viewings || estate?.viewings?.length == 0 || !hasBookableViewing) && estate != null && estate?.status.name != (0, $cUbQm.EstateStatuses).Sold && estate?.status.name != (0, $cUbQm.EstateStatuses).SoldOut && /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("h3", {
                                    className: "font-icb text-blue700 text-xl",
                                    children: "Intresseanm\xe4lan"
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                                    className: "mb-2 text-black500 text-tiny leading-4",
                                    children: "Anm\xe4l ditt intresse s\xe5 h\xe5ller vi dig uppdaterad."
                                })
                            ]
                        }),
                        (!estate?.viewings || !hasBookableViewing) && estate != null && estate?.status.name != (0, $cUbQm.EstateStatuses).Sold && estate?.status.name != (0, $cUbQm.EstateStatuses).SoldOut && /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                            className: "bg-blue700 mt-2 mb-2 px-3 py-3 rounded-md w-full font-icb text-white viewing-booking-button hover-darken-blue",
                            onClick: (e)=>{
                                setShowHideBookModal(true);
                                setDataLayerClick(true);
                            },
                            children: "Anm\xe4l intresse"
                        }),
                        showHideModal && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($c8e2181a3f3fb72d$var$ViewingBooking, {
                                setShowHideModalFunction: setShowHideModal
                            })
                        }),
                        showHideBookModal && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($c8e2181a3f3fb72d$var$InterestForm, {
                                customerId: "S13117",
                                estateAddress: estate?.addressInfo?.streetAddress,
                                estateId: objectId,
                                estateCity: estate?.addressInfo?.city,
                                agentEmail: estate?.brokers[0]?.email,
                                estateType: estate?.estateTypeAsString,
                                setShowHideModalFunction: setShowHideBookModal
                            })
                        })
                    ]
                }),
                dataLayerClick && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.HelmetProvider), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.Helmet), {
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("script", {
                            children: `
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'intresseklick',
                'eventInfo': {
                    'intressetyp': '${hasBookableViewing ? "Visning" : estate?.estateTypeAsString === "Nyproduktion" ? "Nyproduktion" : "Intresse"}'
                }
            });
          `
                        })
                    })
                })
            ]
        })
    });
}

});
parcelRegister("eYlF4", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("74Z0M")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("a9zu4"))
]).then(()=>parcelRequire("81MIW"));

});

parcelRegister("gG0gS", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("iG5lV")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("74Z0M")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("6riAj"))
]).then(()=>parcelRequire("kd4pA"));

});

parcelRegister("b2JAe", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("kzlmc")).then(()=>parcelRequire("3mB8X"));

});


})();
//# sourceMappingURL=ObjectViewing.e15e5d23.js.map
